// extracted by mini-css-extract-plugin
module.exports = {"container":"JobSnippet_container__98_xr","title":"JobSnippet_title__DLYIr"};